module.exports = __webpack_public_path__ + "img/user-avate-test.5348f26f.png";